module.exports = __webpack_public_path__ + "img/10H.60ab387c.png";